export default __webpack_public_path__ + "static/media/434.24575476.jpg";